var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { RadixFlyOut } from "../primitives/RadixFlyOut";
import { OrderTimeSelectionFields } from "./OrderTimeSelectionFields";
import "./orderTimeSelectionFlyOut.css";
export var OrderTimeSelectionFlyOut = function (_a) {
    var open = _a.open, onOpenChange = _a.onOpenChange, onSelectionApplied = _a.onSelectionApplied, fieldsProps = __rest(_a, ["open", "onOpenChange", "onSelectionApplied"]);
    return (React.createElement(RadixFlyOut, { open: open, onOpenChange: onOpenChange, title: "Select order time", description: "Choose ASAP or schedule your order for a future time." },
        React.createElement(OrderTimeSelectionFields, __assign({}, fieldsProps, { onSelectionApplied: function () {
                onSelectionApplied === null || onSelectionApplied === void 0 ? void 0 : onSelectionApplied();
                onOpenChange(false);
            }, containerClassName: "vertical-checkout-flyout-form" }))));
};
